import { RHFTextField, FormProvider } from "@app/components";
import { Strings } from "@app/constants";
import { Stack, Typography, useTheme, Button } from "@mui/material";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { ContactSoonDialog } from "../../../components/modals/contact-soon-dialog";
import { yupResolver } from "@hookform/resolvers/yup";
import { checkValutionSchema } from "../validators";

const CheckValuation = () => {
  const theme = useTheme();
  const methods = useForm({
    resolver: yupResolver(checkValutionSchema) as any,
    defaultValues: {
      carNumber: "",
      phone: "",
    },
  });
  const [open, setOpen] = useState(false);

  const onSubmit = (form: any) => {
    setOpen(true);
    methods.reset();
  };
  return (
    <FormProvider methods={methods} onSubmit={methods.handleSubmit(onSubmit)}>
      <Stack>
        <Stack
          sx={{
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            border: `1px solid ${theme.palette.grey[200]}`,
            borderRadius: 5,
            padding: 5,
            m: 5,
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: 22, sm: 24 },
              fontWeight: "bold",
            }}
          >
            {Strings.step.brand.enterYourCarNumber}
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: theme.palette.grey[500], textAlign: "center" }}
          >
            {Strings.step.brand.pleaseProvideYourVehicle}
          </Typography>
          <RHFTextField
            name={"carNumber"}
            placeholder={Strings.step.brand.egDL34AC4564}
            inputProps={{
              style: { textTransform: "uppercase" },
            }}
            sx={{
              mt: 3,
              width: { xs: "100%", sm: "45%" },
            }}
          />
          <RHFTextField
            name="phone"
            placeholder="Phone"
            sx={{
              width: { xs: "100%", sm: "45%" },
            }}
          />

          <Button type="submit" variant="contained">
            {Strings.button.submit}
          </Button>
        </Stack>
      </Stack>

      <ContactSoonDialog open={open} onClose={() => setOpen(false)} />
    </FormProvider>
  );
};

export { CheckValuation };
